<style>

.wevo-loading-position {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  text-align: center;
  line-height: 50;
  top:0;
  left: 0;
  width: 100%; 
  height: 100%;
}

</style>

<template>
  <div>
    <div v-if="showLoading" class="wevo-loading-position">
      <v-progress-circular 
        :size="70" 
        :width="7" 
        color="white" 
        indeterminate>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLoading: Boolean
  }
};
</script>